import { FieldProps, getIn } from 'formik';
import React, { FC }         from 'react';
import { ZipCodeInput }      from '../inputs/ZipCodeInput/ZipCodeInput';

interface IProps extends FieldProps {
  id?: string;
}

export const ZipCodeInputField: FC<IProps> = ({
  form,
  field,
  ...props
}) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <ZipCodeInput
      {...field}
      {...props}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
    />
  );
};
